import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

import { Button, Icon, List, Popover } from '@/ui'
import { RailNavList } from './RailNavList'
import { Header } from './RailHeader'

interface RailProps {
  device: string
  dropdownOptions: Array<{ icon: IconProp; onClick: () => void; text: string }>
  categories?: Record<
    string,
    {
      end?: boolean
      icon?: IconProp
      label: string
      to?: string
      disabled?: boolean
    }
  > | null
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onCategoryClick?: (key: string) => void
}

export const Rail = ({
  device,
  dropdownOptions,
  categories,
  isOpen,
  setIsOpen,
  onCategoryClick,
}: RailProps) => {
  return (
    <nav className="flex flex-col background-app h-screen w-fit overflow-y-auto pt-6 p-2">
      <div className="space-y-6">
        <Header
          device={device}
          handleIconClick={() => setIsOpen(true)}
          isOpen={isOpen}
        />

        <RailNavList
          categories={categories}
          onCategoryClick={onCategoryClick}
        />
      </div>

      <footer className="mt-auto pt-6">
        <Popover>
          <Popover.Trigger asChild>
            <Button
              className="flex justify-between w-full cursor-pointer"
              iconLeft={regular('user')}
              variant="ghost"
            />
          </Popover.Trigger>

          <Popover.Content align="end" className="w-fit">
            <List className="flex flex-col">
              {dropdownOptions.map(({ icon, onClick, text }) => (
                <List.Item
                  onClick={onClick}
                  key={text}
                  className="flex flex-row gap-2 cursor-pointer"
                >
                  <Icon icon={icon} className="mr-2 h-4 w-4 flex-shrink-0" />

                  <span className="flex-1">{text}</span>
                </List.Item>
              ))}
            </List>
          </Popover.Content>
        </Popover>
      </footer>
    </nav>
  )
}
